import React from 'react';
import classNames from 'classnames';
import classes from '../index.module.scss';
import { SkeletonRoundProps } from '../types';

const SkeletonRound = ({ size = 48, maxSize, dataTestId }: SkeletonRoundProps) => (
  <div
    className={classNames(classes.skeletonBackground, classes.skeletonRound)}
    style={{
      width: size,
      height: size,
      maxHeight: maxSize,
      maxWidth: maxSize,
    }}
    data-testid={dataTestId}
  />
);

SkeletonRound.displayName = 'SkeletonRound';

export default SkeletonRound;
